import checkRouterUrls from "@utils/checkRouterUrls";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import styled from "styled-components";

const TransitionBar = styled.div`
  background-color: #6600ff;
  height: 4px;
  transition: width 0.45s cubic-bezier(0.25, 0.1, 0.25, 1);
  width: 0;

  &.opening {
    width: 85% !important;
  }

  &.open {
    width: 100% !important;
  }
`;

const OPENING_DURATION = 500;

const PageTransitionBar = () => {
  const router = useRouter();
  const [animation, setAnimation] = useState(false);

  useEffect(() => {
    const fixUrl = checkRouterUrls(router.asPath, router.pathname);
    if (fixUrl && fixUrl !== "/") {
      router.push(fixUrl);
    }
  }, []);

  const handleStart = () => {
    if (animation && animation.timeout) clearTimeout(animation.timeout);
    setAnimation({
      status: "opening",
      timeout: setTimeout(() => {
        setAnimation({
          status: "open",
        });
      }, OPENING_DURATION),
    });
  };

  const handleStop = () => {
    if (animation && animation.timeout) clearTimeout(animation.timeout);
    setAnimation(false);
  };

  useEffect(() => {
    router.events.on("routeChangeStart", handleStart);
    router.events.on("routeChangeComplete", handleStop);
    router.events.on("routeChangeError", handleStop);

    return () => {
      router.events.off("routeChangeStart", handleStart);
      router.events.off("routeChangeComplete", handleStop);
      router.events.off("routeChangeError", handleStop);
    };
  }, [router]);

  const classes = animation ? animation.status : "";

  return <TransitionBar className={classes} />;
};

export default PageTransitionBar;
